import { FC } from "react"
import { Notification } from "../../../types/global/types"
import { useTranslation } from "../../../hooks/useTranslation"
import "./styles.scss"

type Props = {
  notification: Notification,
}

export const RemindMeNotification: FC<Props> = ({
  notification,
}) => {
  const { t } = useTranslation()

  const notesText = notification.notes == null
    ? ''
    : typeof notification.notes === 'string' ? notification.notes : JSON.stringify(notification.notes)

  return (
    <div
      className="notification"
    >
      <div className="notification__header">
        <div className="notification__title">
          <h3>
            {notification.title.startOfTitle}
            {notification.title.householdName}
            {notification.title.endOfTitle}
          </h3>
          <div className="notification__time">
            {notification.created_at_formatted}
          </div>
        </div>
      </div>

      <div className="notification__notes">
        <div className="notification__notes-header">{t("common.date")}</div>
        <div className="notification__notes-body">
          {notification.remind_me_at_date}
        </div>
      </div>

      <div className="notification__notes">
        <div className="notification__notes-header">{t("common.time")}</div>
        <div className="notification__notes-body">
          {notification.remind_me_at_time}
        </div>
      </div>

      {!!notesText && (
        <div className="notification__notes">
          <div className="notification__notes-header">{t("common.notes")}</div>
          <div className="notification__notes-body">{notesText}</div>
        </div>
      )}
    </div>
  )
}
